import {
  linearProgressClasses,
  stepIconClasses,
  stepLabelClasses,
  svgIconClasses,
  type SxProps,
  type Theme,
} from '@mui/material';

export const QuoteStepperStyle: SxProps<Theme> = {
  fontSize: (theme) => theme.typography.body2.fontSize,
  paddingInline: '1.13rem',
  paddingBlock: '.5rem calc(.5rem + .25rem + 1em)',
  mb: 2,
  mt: -2,
};

export const QuoteStepperMainStepStyle: SxProps<Theme> = {
  position: 'relative',
  flex: '0',
  paddingInline: '.25rem',

  [`.${stepLabelClasses.labelContainer}`]: {
    position: 'absolute',
    top: 'calc(100% + .25rem)',
    width: 'max-content',

    [`.${stepLabelClasses.label}`]: {
      marginTop: '0',
      fontSize: (theme) => theme.typography.body2.fontSize,
      lineHeight: (theme) => theme.typography.body2.lineHeight,
      color: (theme) => theme.customStyling.quoteStepper.primary,

      [`&.Mui-completed`]: {
        color: (theme) => theme.customStyling.quoteStepper.completedText,
      },
    },
  },

  [`.${svgIconClasses.root}`]: {
    border: '1px solid transparent',
    borderRadius: '100%',
  },

  [`.${stepLabelClasses.iconContainer}`]: {
    [`.${svgIconClasses.root}`]: {
      fill: (theme) => theme.customStyling.quoteStepper.primary,
    },
    [`.${stepIconClasses.text}`]: {
      fill: (theme) => theme.customStyling.quoteStepper.activeIconText,
    },

    [`&.Mui-completed`]: {
      [`.${stepIconClasses.root}`]: {
        fill: (theme) => theme.customStyling.quoteStepper.completedIconCircle,
        backgroundColor: (theme) => theme.customStyling.quoteStepper.primary,
      },
    },
  },

  [`&:last-of-type`]: {
    [`.${stepLabelClasses.label}:not(.Mui-active, .Mui-completed)`]: {
      opacity: '40%',
    },
    [`.${stepLabelClasses.iconContainer}:not(.Mui-active, .Mui-completed)`]: {
      opacity: '50%',
    },
  },

  [`&:not(&:last-of-type) .Mui-disabled`]: {
    [`.${stepLabelClasses.label}`]: {
      color: (theme) => theme.customStyling.quoteStepper.disabled,
    },
    [`.${svgIconClasses.root}`]: {
      borderColor: (theme) => theme.customStyling.quoteStepper.disabled,
      fill: 'transparent',
    },
    [`.${stepIconClasses.text}`]: {
      fill: (theme) => theme.customStyling.quoteStepper.disabled,
    },
  },
};

export const QuoteStepperLinearProgressStyle: SxProps<Theme> = {
  height: '3px',
  flex: '1',
  top: 'calc(1.5rem / 2 - 1.5px)',
  borderRadius: 5,
  backgroundColor: (theme) => theme.customStyling.quoteStepper.progressBarBG,

  [`.${linearProgressClasses.bar}`]: {
    backgroundColor: (theme) => theme.customStyling.quoteStepper.primary,
    borderRadius: 5,
  },
};
